"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sanitizingStringifyReplacer = void 0;
const lodash_1 = __importDefault(require("lodash"));
const common_1 = require("./common");
const Validator_1 = require("./Validator");
function sanitizingStringifyReplacer() {
    const seen = new WeakSet();
    return (key, value) => {
        if (value instanceof RegExp) {
            value = value.toString();
        }
        if (lodash_1.default.isEmpty(key) && lodash_1.default.isString(value)) {
            // root item passed was a string
            const lowered = (value ?? '').toLowerCase();
            /* eslint-disable-next-line fp/no-loops, fp/no-let, no-plusplus */
            for (let i = 0; i < common_1.SECURE_KEY_LIST.length; i++) {
                if (lodash_1.default.includes(lowered, common_1.SECURE_KEY_LIST[i])) {
                    return '<SANITIZED>';
                }
            }
        }
        if (typeof value === 'object' && value != null) {
            if (seen.has(value)) {
                return '<CIRCULAR>';
            }
            seen.add(value);
        }
        const secureKey = (key ?? '').toLowerCase();
        // if the normalized key exists in the block map replace it with <SANITIZED>
        // otherwise allow the original key
        if (common_1.SECURE_KEY_MAP[secureKey]) {
            return '<SANITIZED>';
        }
        // check all strings for email addresses
        if (typeof value === 'string' &&
            value.includes('@') &&
            Validator_1.Validator.validate('email', value)) {
            return value.replace(/\b[!#$%&'*+\-/=?^_`{|}~a-zA-Z0-9\.]+@[a-zA-Z0-9\.\-]+\b/g, '<SANITIZED>@<SANITIZED>');
        }
        return value;
    };
}
exports.sanitizingStringifyReplacer = sanitizingStringifyReplacer;
//# sourceMappingURL=Sanitizers.js.map